import React from 'react'

import { usePPGDaljabHook } from './usePPGDaljabHook'

import type { TAPIGetProfilePPGDaljabResponse } from 'typings/ppg-daljab'

type PPGDaljabContextType = {
  isLoading: boolean
  isEligible: boolean
  isConfirmed: boolean
  isOnProgressProfile: boolean
  isError: boolean
  data: TAPIGetProfilePPGDaljabResponse | null
  setConfirmed: () => void
}

export const PPGDaljabContextDefaultValue: PPGDaljabContextType = {
  isLoading: true,
  isEligible: false,
  isConfirmed: false,
  isOnProgressProfile: false,
  isError: false,
  setConfirmed: () => {},
  data: null,
}

export const PPGDaljabContext = React.createContext(
  PPGDaljabContextDefaultValue
)

PPGDaljabContext.displayName = 'PPGDaljabContext'

export function usePPGDaljabContext() {
  const context = React.useContext(PPGDaljabContext)
  if (context === undefined) {
    throw new Error(
      'PPGDaljabContextContext must be used within a FeatureContextProvider'
    )
  }
  return context
}

export function WithPPGDaljabContext(props: any) {
  const PPGDaljabValue = usePPGDaljabHook()
  return <PPGDaljabContext.Provider value={PPGDaljabValue} {...props} />
}
